import { useOptionalTourContext } from "../../contexts/TourContext";
import DemandStudioTourRunner from "./DemandStudioTourRunner";

// The layout takes its state hook as a prop, so it can be hosted outside the
// shell. No provider means no tour.
const DemandStudioTour = () => {
   const hasTourProvider = Boolean(useOptionalTourContext());

   return hasTourProvider ? <DemandStudioTourRunner /> : null;
};

export default DemandStudioTour;
